import { useEffect } from 'react';
import type { Initiative } from '../../../../api/initiative-client/initiative-client.type';
import i18n from '../../../../base-dictionary';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { Table } from '../../../../components/table/table';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { useStrategyStore } from '../../../../store/strategy-store/strategy-store';
import { resetPage, setPage, setSelectedInitiative } from '../../../../store/strategy-store/strategy-store.actions';
import { useFilteredInitiatives, useFiltersApplied } from '../../strategy-v2.hooks';
import { InitiativeRecord } from '../../strategy-v2.type';
import { customSort, getTableColumns } from './main-section.helpers';

export const MainSectionTable = () => {
  const page = useStrategyStore((state) => state.page);
  const portfolio = useGlobalStore((state) => state.portfolio);
  const selectedInitiative = useStrategyStore((state) => state.selectedInitiative);

  const { initiatives } = useFilteredInitiatives();
  const filtersApplied = useFiltersApplied();

  useEffect(() => {
    if (portfolio) {
      resetPage();
    }
  }, [portfolio]);

  if (!filtersApplied) {
    return <ContentPlaceholder icon="filter_list" text={i18n.t('strategy.filters.no_filters_applied')} />;
  }

  if (initiatives.length === 0) {
    return <ContentPlaceholder />;
  }

  return (
    <Table<InitiativeRecord>
      data={initiatives}
      columns={getTableColumns()}
      getRowId={(initiative: Initiative) => initiative.id}
      defaultSortedBy={'name'}
      stickyHeader
      onRowClick={setSelectedInitiative}
      currentPage={page}
      totalItems={initiatives.length}
      onPageChange={setPage}
      customSort={customSort}
      selectedRowId={selectedInitiative?.id}
    />
  );
};
